<div class="page-content">
<app-header></app-header>
<router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<app-cookies-msg></app-cookies-msg>
